import { Controller } from 'react-hook-form';
import { IconBlock, IconEdit, IconSelected } from '@ui/src';
import { LanguagesFormTypes } from './types';

import cn from './styles.module.css';

const LanguagesForm = ({
  control,
  availableNameKey,
  notAvailableNameKey,
  setEditPanelType,
  setEditKey,
  setEditPanelIsOpen,
  setNotEditKey,
  type,
}: LanguagesFormTypes) => (
  <div className={cn.languagesContentWrapper}>
    <div className={cn.languagesContentTop}>
      <div className={cn.languagesContentTitle}>
        <div className={cn.languagesContentTitleLeft}>
          <div className={cn.contentWrapper}>
            <IconSelected />
          </div>
          <div className={cn.contentWrapper}>Available languages</div>
        </div>
        <button
          type="button"
          className={cn.editButton}
          onClick={() => {
            setEditPanelIsOpen(true);
            setEditPanelType(type);
            setEditKey(availableNameKey);
            setNotEditKey(notAvailableNameKey);
          }}
        >
          <IconEdit width={16} height={16} /> Edit
        </button>
      </div>
      <Controller
        control={control}
        name={availableNameKey}
        render={({ field: { value } }) => (
          <div className={cn.languagesList}>
            {value?.length ? (
              value?.map((item) => (
                <div className={cn.languageItem} key={item}>
                  {item}
                </div>
              ))
            ) : (
              <div className={cn.emptyList}>No selected languages yet</div>
            )}
          </div>
        )}
      />
    </div>
    <div className={cn.languagesContentSeparator} />
    <div className={cn.languagesContentBottom}>
      <div className={cn.languagesContentTitle}>
        <div className={cn.languagesContentTitleLeft}>
          <div className={cn.contentWrapper}>
            <IconBlock width={15} height={15} />
          </div>
          <div className={cn.contentWrapper}>Not available languages</div>
        </div>
        <button
          type="button"
          className={cn.editButton}
          onClick={() => {
            setEditPanelIsOpen(true);
            setEditPanelType(type);
            setEditKey(notAvailableNameKey);
            setNotEditKey(availableNameKey);
          }}
        >
          <IconEdit width={16} height={16} /> Edit
        </button>
      </div>
      <Controller
        control={control}
        name={notAvailableNameKey}
        render={({ field: { value } }) => (
          <div className={cn.languagesList}>
            {value?.length ? (
              value?.map((item) => (
                <div className={cn.languageItem} key={item}>
                  {item}
                </div>
              ))
            ) : (
              <div className={cn.emptyList}>No selected languages yet</div>
            )}
          </div>
        )}
      />
    </div>
  </div>
);

export default LanguagesForm;
